module.exports = __webpack_public_path__ + "img/Strip-Front-B4-Jc.c636bf86.png";